import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ProductCard } from '../components/ProductCard';
import { ProductModal } from '../components/ProductModal';
import { trackPageview } from '../utils/tracking';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PRODUCT_LINEUP_LIGHT = "https://customer-assets.emergentagent.com/job_da8972b2-30fe-4905-bc28-1222202a53f5/artifacts/00a1qfib_file_00000000fdd871f89511e95ea5dc2348.png";

export const ShopPage = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    trackPageview('shop', '/shop');
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleViewBlend = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="shop-page">
      {/* Hero Banner */}
      <section className="bg-white border-b border-[#E5E0D8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h1 className="font-['Bodoni_Moda'] text-4xl sm:text-5xl font-bold text-[#2A2A2A] mb-4">
                Shop the Blends
              </h1>
              <p className="text-[#666] text-base sm:text-lg max-w-xl">
                Four bold blends, each crafted to make your food taste like you know exactly what you're doing. No fuss. Just flavor.
              </p>
            </div>
            <div className="flex-1 flex justify-center">
              <img
                src={PRODUCT_LINEUP_LIGHT}
                alt="Country Bo Seasonings"
                className="max-w-full h-auto max-h-[300px] object-contain"
                data-testid="shop-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="bg-white rounded-xl h-[400px] animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="products-grid">
              {products.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onViewBlend={handleViewBlend}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Product Modal */}
      <ProductModal
        product={selectedProduct}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};

export default ShopPage;
